import { HTMLAttributes } from 'react'
import { InputDateRangePreset } from '@dashboard/ui'
import { DeviceType, FilterType, OrderSourceType, UserSourceType } from '@/api/dashboard'
import { getObjectParamsFromDateRange } from '@/layouts/dashboard/util'

export interface ChartProps extends HTMLAttributes<HTMLDivElement> {
  filters: {
    selectedFilter: InputDateRangePreset
    type: FilterType
    demoSelectedFilter: string
    order_source?: OrderSourceType
    device_type?: DeviceType
    countries?: string
  }
}

export const getQueryParams = (filters: ChartProps['filters']) => {
  return {
    ...getObjectParamsFromDateRange(filters.selectedFilter.range),
    type: filters.type,
    order_source: filters.order_source,
    device_type: filters.device_type,
    countries: filters.countries,
  }
}

export const getQueryParamsWithoutOrder = (filters: ChartProps['filters']) => {
  return {
    ...getObjectParamsFromDateRange(filters.selectedFilter.range),
    type: filters.type,
    user_source: filters.order_source as unknown as UserSourceType,
    device_type: filters.device_type,
    countries: filters.countries,
  }
}
